import { useCallback } from 'react';
import { SourceType } from '@/modules/surgicalEvent';
import { useUserAppSetting } from '@/modules';
import { useIsHospitalModuleEnabled } from '@/modules/appContext';

export const usePatientsAppFilter = () => {
  const patientsAppModuleEnabled = useIsHospitalModuleEnabled('patientsApp');
  const patientsAppIntegrationEnabled = useUserAppSetting(
    'patientsAppIntegrationEnabled',
    true
  );

  const shouldFilterOut = useCallback(
    (sourceType?: SourceType) => {
      // If the module is not enabled, don't filter (let items through)
      if (!patientsAppModuleEnabled) {
        return false;
      }

      // If integration is enabled, don't filter (let items through)
      if (patientsAppIntegrationEnabled) {
        return false;
      }

      // Integration is disabled, filter out PATIENTS_APP items
      return sourceType === SourceType.PATIENTS_APP;
    },
    [patientsAppModuleEnabled, patientsAppIntegrationEnabled]
  );

  const filterItems = useCallback(
    <T extends { sourceType?: SourceType }>(items: T[]): T[] => {
      if (!patientsAppModuleEnabled || patientsAppIntegrationEnabled) {
        return items;
      }
      return items.filter((item) => !shouldFilterOut(item.sourceType));
    },
    [patientsAppModuleEnabled, patientsAppIntegrationEnabled, shouldFilterOut]
  );

  return {
    shouldFilterOut,
    filterItems,
    isFilteringActive:
      patientsAppModuleEnabled && !patientsAppIntegrationEnabled
  };
};
